import React,{useState,useEffect} from 'react'
import { BoxAbi } from "./Contracts/Box";
import { saveAs } from "file-saver";
import { useAccount } from "wagmi";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import axios from "axios";
import { useSigner } from "wagmi";
import { ethers } from "ethers";
import Profile from './Profile';


const UserFiles = () => {
    const newAddress=localStorage.getItem("newaddress");
    const JWT = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI3MzVmZGI5My00NWVjLTRiOWQtODgxMi1mMDhhYWRkMjI3YWUiLCJlbWFpbCI6ImZhaGVlbWZlcm96MTExOUBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJpZCI6IkZSQTEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX0seyJpZCI6Ik5ZQzEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiM2JkYzdhZjYxYTkxNDBjM2FhOTIiLCJzY29wZWRLZXlTZWNyZXQiOiI5NmU5MTM5ZTlhYTQ2ZDhmZDRjMWM4ZjdiM2EyZGEzNGQzY2EyODY0N2U3ODRkYTliY2E0MmNkOTE2NTA4MzM3IiwiaWF0IjoxNjc5OTkxNTg5fQ.iTA1cmseF9_LFXFVgVIUfV_Q7UzqVBkhQ60XpScuhyE`;
    const [selectedFile, setSelectedFile] = useState();
    const { data: signer } = useSigner();
    const [showFiles, setShowFiles] = useState([]);
    let boxcontract;
    if (signer) {
      boxcontract = new ethers.Contract(newAddress, BoxAbi, signer);
    }
    const downloadFile = (url, fileName) => {
        fetch(url)
          .then((response) => {
            return response.blob();
          })
          .then((blob) => {
            saveAs(blob, fileName);
          });
      };
  
    const changeHandler = (event) => {
        setSelectedFile(event.target.files[0]);
      };

    
      const handleSubmission = async () => {
        const formData = new FormData();
    
        formData.append("file", selectedFile);
    
        const metadata = JSON.stringify({
          name: selectedFile?.name,
        });
    
        formData.append("pinataMetadata", metadata);
    
        const options = JSON.stringify({
          cidVersion: 0,
        });
        formData.append("pinataOptions", options);
    
        try {
          await axios
            .post("https://api.pinata.cloud/pinning/pinFileToIPFS", formData, {
              maxBodyLength: "Infinity",
              headers: {
                "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
                Authorization: JWT,
              },
            })
            .then(async (responce) => {
              const size = responce.data.PinSize / 1024;
              const sizeKb = Math.round(size);
              const splitted = selectedFile?.name.split(".");
              const type = splitted[1];
              console.log("splitted", type);
              await boxcontract
                .addFile(
                  "https://gateway.pinata.cloud/ipfs/" +
                    responce?.data?.IpfsHash?.replaceAll('"', ""),
                  sizeKb,
                  selectedFile?.name
                )
                .then((tx) =>
                  tx.wait().then(() => toast.success("Uploaded Successfully"))
                );
            });
        } catch (error) {
          console.log(error);
        }
      };
      const getFiles = async () => {
        await boxcontract.getAllFile().then((res) => {
          console.log("Get Files", res);
          setShowFiles(res);
        });
      };
      useEffect(() => {
        if (signer) {
         
          getFiles();
         
        }
      }, [signer]);
  return (
    <>
       <Toaster position="top-center" reverseOrder={false} />
      <div className="antialiased bg-[#212445] w-full min-h-screen text-slate-300 relative py-4">
    <div className="grid grid-cols-12 mx-auto gap-2 sm:gap-4 md:gap-6 lg:gap-10 xl:gap-14 max-w-7xl my-10 px-2">
      <Profile />
      <div className=" w-full">
       

        <h1 className="text-3xl text-white my-10">Files</h1>
        {showFiles?.map((item, index) => (
          <div key={index} className="flex gap-40 justify-between">
            <h1 className="text-white w-1/2">{item.fileType}</h1>

            <h1
              className="text-white hover:cursor-pointer w-1/2"
              onClick={() => downloadFile(item.uri, item.fileType)}
            >
              Download File
            </h1>
          </div>
        ))}
      </div>
    </div>
    </div>
  </>
  )
}

export default UserFiles
